module.exports = __webpack_public_path__ + "img/1620746956.006320fa.jpg";